import ReactCountryFlag from 'react-country-flag';
import UIIcon from 'components/UI/Icon/Icon';
import './DisplayItem.scss';

const cbn = 'form-station-selector-display-item';

type StationSelectorDisplayItemProps = {
  readonly name: string;
  readonly type: string;
  readonly country: string;
  readonly stationIcon: string;
};

function StationSelectorDisplayItem({
  name,
  type,
  country,
  stationIcon,
}: Readonly<StationSelectorDisplayItemProps>) {
  const resizedImage = stationIcon?.replace(/w=\d+&h=\d+/, 'w=32&h=24');
  return (
    <div className={cbn}>
      <div className={`${cbn}__photo`}>
        {resizedImage ? (
          <img src={resizedImage} alt={name} />
        ) : (
          <UIIcon type="open_in_new" />
        )}
        <UIIcon type={stationIcon} />
      </div>
      <div className={`${cbn}__metadata`}>
        <div>
          <h1 className={`${cbn}__metadata-name`}>{name}</h1>
        </div>
        <div className={`${cbn}__metadata-subtitle`}>
          <ReactCountryFlag countryCode={country} />
          <span className={`${cbn}__metadata-country-type`}>
            {country} - {type}
          </span>
        </div>
      </div>
    </div>
  );
}

export default StationSelectorDisplayItem;
